import { render, staticRenderFns } from "./AddTagsModal.vue?vue&type=template&id=75ddd73f&scoped=true&"
import script from "./AddTagsModal.vue?vue&type=script&lang=js&"
export * from "./AddTagsModal.vue?vue&type=script&lang=js&"
import style0 from "./AddTagsModal.vue?vue&type=style&index=0&id=75ddd73f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75ddd73f",
  null
  
)

export default component.exports